export enum FontWeight {
  Regular = '400',
  SemiBold = '600',
  Bold = '700',
}

export const FontWeights = Object.values(FontWeight)
